module.exports = __webpack_public_path__ + "img/쿠폰.b1b8fcac.png";